// Forgot-password route (public): asks for the email address and always confirms the same way.
import { createFileRoute } from "@tanstack/react-router";

import { ForgotPasswordPage } from "@/features/auth/ForgotPasswordPage";

export const Route = createFileRoute("/forgot-password")({
  component: ForgotPasswordPage,
});
